import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid", "onClick", "onKeydownPassive"]
const _hoisted_3 = ["name", "value", "data-test-value"]
const _hoisted_4 = {
  class: "lottery-numbers-picker__cell-number",
  "data-test": "number"
}
const _hoisted_5 = {
  key: 0,
  class: "lottery-numbers-picker__cell-multiplier"
}

import { computed } from "vue";
import { KamenyBetOption } from "../data/kameny-constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'lottery-numbers-picker',
  props: /*@__PURE__*/_mergeModels({
    maxBoardSize: {},
    minBoardSize: {},
    numbersCount: {},
    numbersOffset: { default: 0 },
    hotNumbers: {},
    coldNumbers: {},
    multipliers: {},
    dataTestid: {}
  }, {
    "filling": { required: false },
    "fillingModifiers": {},
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["numberPicked"], ["update:filling", "update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const filling = _useModel<string>(__props, "filling");

const props = __props;

const modelValue = _useModel<number[]>(__props, "modelValue");

const boardNumbers = computed(() => Array.from({ length: props.numbersCount }, (_, index) => index + 1));

const isFull = computed(() => modelValue.value?.length >= props.maxBoardSize);

const isValid = computed(() => {
    if (props.minBoardSize) {
        return props.minBoardSize <= modelValue.value?.length && props.maxBoardSize >= modelValue.value?.length;
    }

    return isFull.value;
});

const preventOverfill = (numberToAdd: number) => {
    const index = modelValue.value.indexOf(numberToAdd);

    if (isFull.value && index === -1) {
        return;
    }

    if (index !== -1) {
        modelValue.value.splice(index, 1);
    } else {
        modelValue.value.push(numberToAdd);
    }

    emit("numberPicked");
    filling.value = "manual";
};

const handleKeydown = (numberToAdd: number) => {
    let modified = false;
    if (modelValue.value.includes(numberToAdd)) {
        modelValue.value = modelValue.value.filter((number) => number !== numberToAdd);

        modified = true;
    } else if (!isFull.value) {
        modelValue.value = [...modelValue.value, numberToAdd];

        modified = true;
    }

    if (modified) {
        filling.value = "manual";
    }
};

const multipliersFormatted = computed(() => {
    const formatted = new Map<number, string>();

    if (props.multipliers) {
        props.multipliers.forEach((item) => {
            formatted.set(item.id, `${item.multiplier.toLocaleString("en").replace(/,/g, "\u00A0")}x`);
        });
    }

    return formatted;
});

__expose({ isFull, isValid });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "lottery-numbers-picker",
    "data-test": "numbers-board",
    "data-testid": _ctx.dataTestid
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boardNumbers.value, (number) => {
      return (_openBlock(), _createElementBlock("label", {
        key: `primary-${number}`,
        class: "lottery-numbers-picker__cell",
        "data-testid": `${number}${modelValue.value.includes(number) ? '-selected' : ''}`,
        onClick: _withModifiers(($event: any) => (preventOverfill(number)), ["prevent"]),
        onKeydownPassive: _withKeys(($event: any) => (handleKeydown(number)), ["enter"])
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "lottery-numbers-picker__cell-checkbox",
          type: "checkbox",
          name: number.toString(),
          value: number,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          "data-test": "checkbox-number",
          "data-test-value": number + _ctx.numbersOffset
        }, null, 8, _hoisted_3), [
          [_vModelCheckbox, modelValue.value]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["lottery-numbers-picker__cell-number-wrapper", [
                    { 'lottery-numbers-picker__cell-number-wrapper--hot': _ctx.hotNumbers?.includes(number) },
                    { 'lottery-numbers-picker__cell-number-wrapper--cold': _ctx.coldNumbers?.includes(number) },
                    {
                        'lottery-numbers-picker__cell-number-wrapper--active':
                            modelValue.value.includes(number) && multipliersFormatted.value.has(number),
                    },
                ]])
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(number + _ctx.numbersOffset), 1),
          (multipliersFormatted.value.has(number))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(multipliersFormatted.value.get(number)), 1))
            : _createCommentVNode("", true)
        ], 2)
      ], 40, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}
}

})